import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function GuaranteeSection() {
  return <section className="w-full bg-cream-100 px-6 py-14 sm:py-16" aria-labelledby="garantia-titulo" data-id="element-80" data-mp="4vjmq3szb4em">
      <div className="mx-auto max-w-2xl text-center" data-id="element-81" data-mp="9t1ptdkbepep">
        <SectionHeading id="garantia-titulo" badge="Tu inversión está 100% protegida" badgeIcon={ShieldCheckIcon} title="Garantía de 7 Días, Sin Preguntas" data-id="element-82" data-mp="etpmofv860gu" />

        <div className="mt-7 rounded-2xl border border-cream-300/70 bg-cream-50 p-7" data-id="element-83" data-mp="nt2nyl973iqh">
          <p className="text-base leading-relaxed text-forest-700/90" data-id="element-84" data-mp="skkoj87b3hax">
            Abrís los volúmenes. Los usás en clase o laboratorio. Si en 7 días no es lo que esperabas,
            solicitás tu devolución completa del 100% sin formularios ni condiciones.
          </p>
          <p className="mt-6 inline-block rounded-full bg-cream-100 px-4 py-2 text-sm font-semibold text-forest-700" data-id="element-85" data-mp="17i4q054zuucc">
            Tasa de devoluciones: menor al 0.5%
          </p>
        </div>
      </div>
    </section>;
}